import React from 'react';
import FlowPane from './index';
import { ReactFlowProvider } from 'react-flow-renderer';
import { GanttProvider } from '../../hooks/useGantt';

const PaneProvider = () => (
  <>
    <GanttProvider>
      <ReactFlowProvider>
        <FlowPane />
      </ReactFlowProvider>
    </GanttProvider>
  </>
);

export default PaneProvider;
